import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/subscriptions/page.tsx")